import React from 'react';
import PropTypes from 'prop-types';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {Unveil} from '@homeaway/react-unveil';
import bwcImage from '../../../images/bwc-badge.svg';
import {IconBullet} from '../../IconBullet/IconBullet';
import {Link} from '@homeaway/react-localization-components';

import './ServiceFeeSummary.less';

export class ServiceFeeSummary extends React.PureComponent {
    static propTypes = {
        checkoutUrl: PropTypes.string,
        serviceFeeSummary: PropTypes.shape({
            bodyBulletTexts: PropTypes.arrayOf(PropTypes.string),
            bodyMainText: PropTypes.string,
            bookNowActionString: PropTypes.string,
            bookNowCheckoutUrl: PropTypes.string,
            title: PropTypes.string,
        }),
    };

    get checkoutButton() {
        let button;
        const {checkoutUrl, serviceFeeSummary} = this.props;

        if (serviceFeeSummary.bookNowCheckoutUrl || this.props.checkoutUrl) {
            button = (
                <Link
                    href={checkoutUrl || serviceFeeSummary.bookNowCheckoutUrl}
                >
                    {(localizedUrl) => (
                        <ButtonPrimary
                            block
                            className={'btn--nowrap'}
                            href={localizedUrl}
                            label={serviceFeeSummary.bookNowActionString}
                        />
                    )}
                </Link>
            );
        }

        return button;
    }

    render() {
        const summary = this.props.serviceFeeSummary;
        let bullets = [];

        if (!summary) {
            return null;
        }

        if (summary.bodyBulletTexts && summary.bodyBulletTexts.length > 0) {
            summary.bodyBulletTexts.forEach((text, index) => {
                bullets.push(<IconBullet key={index} text={text} />);
            });
        }

        return (
            <div className="ServiceFeeSummary conversation-sidebar-section rounded-border hidden-print">
                <Unveil
                    className="ServiceFeeSummary__image text-center"
                    backgroundImage={bwcImage()}
                />

                {summary.title && (
                    <h2 className="text-center">{summary.title}</h2>
                )}

                {summary.bodyMainText && (
                    <p className="text-center">{summary.bodyMainText}</p>
                )}

                {summary.bodyBulletTexts && (
                    <ul className="list-unstyled list--vertical-grid">
                        {bullets}
                    </ul>
                )}
                {this.checkoutButton}
            </div>
        );
    }
}
